import styled from 'styled-components';
import { textStyles } from '../styles';
var Span = /*#__PURE__*/styled.span.withConfig({
  displayName: "Span",
  componentId: "sc-1jfq84m-0"
})(["", ";"], textStyles);
Span.displayName = 'Span';
export default Span;